import axios, { AxiosStatic } from 'axios';
import { inject, injectable } from 'tsyringe';
import { AsyncLock } from '../../../shared/utils/async-lock';
import { kDITokenAxios } from '../../bootstrap/vendor.registry';
import { IRemoteObject } from './remote-object.interface';

export const kHeaderLastModified = 'last-modified';
export const kNameOfRemoteObjectHttpFile = 'RemoteObjectHttpFile';
// -----------------------------------------------------------------------------
// TODO(twolf): Test 304 is supported
@injectable()
export class RemoteObjectHttpFile implements IRemoteObject {
  private url: string;

  // ---------------------------------------------------------------------------
  public constructor(
    // NOTE(twolf): We want to use a lock to refrain from bursts of requests
    // going out.
    private readonly singleRequestLock: AsyncLock,
    @inject(kDITokenAxios)
    private readonly axiosImpl: AxiosStatic,
  ) {
    // NOTE(twolf): Not getting an error if kDITTokenAxios isn't registered with
    // tsyringe
    if (!axiosImpl) {
      this.axiosImpl = axios;
    }
  }

  // ---------------------------------------------------------------------------
  // IRemoteObject
  // ---------------------------------------------------------------------------

  initialize(remoteUri: string) {
    this.url = remoteUri;
  }

  // ---------------------------------------------------------------------------
  async getLastModified(): Promise<Date> {
    await this.singleRequestLock.lock();

    try {
      const result = await this.axiosImpl.head(this.url.toString());
      const lastModified = result.headers[kHeaderLastModified];
      return new Date(lastModified);
    } finally {
      await this.singleRequestLock.unlock();
    }
  }

  // ---------------------------------------------------------------------------
  async retrieve<T>(): Promise<[object: T, lastModified: Date]> {
    await this.singleRequestLock.lock();

    try {
      const result = await this.axiosImpl.get<T>(this.url.toString());
      const lastModified = result.headers[kHeaderLastModified];

      return [result.data, new Date(lastModified)];
    } catch {
      return [null, null];
    } finally {
      await this.singleRequestLock.unlock();
    }
  }
}
